import React, { Suspense, useEffect } from "react";
import { Route, Routes, useLocation } from "react-router-dom";
import routes from "../routes";
import Sidebar from "../components/Sidebar";
import Header from "../components/Header";
import Main from "./Main";
import ThemedSuspense from "../components/ThemedSuspense";
import { useDispatch, useSelector } from "react-redux";
import { closeSidebar } from "../features/sidebarSlice";
import { isPathActive } from "../utils/General";
import Div100vh from "react-div-100vh";

function Layout() {
  const isSidebarOpen = useSelector((state) => state["sidebar"].isSidebarOpen);
  const dispatch = useDispatch();
  let location = useLocation();

  useEffect(() => {
    dispatch(closeSidebar());
  }, [dispatch, location]);

  return (
    <Div100vh>
      <div
        className={`flex h-full bg-gray-50 dark:bg-gray-900 ${
          isSidebarOpen ? "overflow-hidden" : ""
        }`}
      >
        <Sidebar />
        <div className="flex flex-col flex-1 w-full">
          <Header />
          <Main isFullScreen={isPathActive("messageBetter")}>
            <Suspense fallback={<ThemedSuspense />}>
              <Routes>
                {routes.map((route, index) => {
                  return route.component ? (
                    <Route
                      key={index}
                      path={`/${route.path}`}
                      element={<route.component />}
                    />
                  ) : null;
                })}
              </Routes>
            </Suspense>
          </Main>
        </div>
      </div>
    </Div100vh>
  );
}

export default Layout;
